import { axiosInstance } from "@/config/axiosInstance";

export const verifyOtp = (data: {
  phone: string;
  orderId: string;
  otp: string;
}) =>
  axiosInstance.post<{
    success: boolean;
  }>("/employee/otp/verify", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const verifyEmailOtp = (data: { email: string; otp: string }) =>
  axiosInstance.post("/employee/email/verify", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
